/** @format */
import { AxiosResponse, CancelToken } from 'axios';

import { MarketCode, euMarket, europeanMarkets } from '@toucan/config/markets';

import { client } from '@toucan/services/request-client';

import {
    Query,
    QueryResponse,
} from '@toucan/client/features/search/config/types';
import { getSearchQueryParams } from '@toucan/common/services/search/search-service';

/**
 * Get search results form the search service for the given query and locale.
 *
 * @format
 * @param {Query} search the search query
 * @param {string} locale The locale to search for results in. E.g. en_GB
 * @returns The search response object
 */

export async function getSearchResults<T>(
    search: Query,
    locale: string,
    marketCode: MarketCode
): Promise<QueryResponse<T>> {
    // TODO - update when modelOperation is added to search-service
    // overrides the product/model (sets to EU) market for EU markets only.
    if (europeanMarkets.includes(marketCode)) {
        if (search?.filterQuery?.productMarket) {
            search.filterQuery.productMarket = euMarket.code;
        }

        if (search?.filterQuery?.modelMarket) {
            search.filterQuery.modelMarket = euMarket.code;
        }
    }

    const queryParams = getSearchQueryParams(search, marketCode);

    const response = await client.get(
        `/search-service/product/query/?${queryParams}`,
        {
            headers: {
                'Content-Language': locale,
            },
        }
    );
    return response.data;
}

export async function fetchQuoteProductConditions(
    queryParams: string,
    cancelToken: CancelToken | undefined,
    locale: string
) {
    const { data }: AxiosResponse<QueryResponse> = await client.get(
        `/search-service/product/query/?${queryParams}`,
        {
            cancelToken,
            headers: {
                'Content-Language': locale,
            },
        }
    );

    return data;
}

export async function fetchQuoteBuyProducts(
    queryParams: string,
    cancelToken: CancelToken | undefined,
    locale: string
) {
    const { data }: AxiosResponse<QueryResponse> = await client.get(
        `/search-service/product/query/?${queryParams}`,
        {
            cancelToken,
            headers: {
                'Content-Language': locale,
            },
        }
    );

    return data;
}
